/**
 * 三泰
 */
export var E_Tristate;
(function (E_Tristate) {
    E_Tristate["Unselect"] = "Unselect";
    E_Tristate["Indeterminate"] = "Indeterminate";
    E_Tristate["Selected"] = "Selected";
})(E_Tristate || (E_Tristate = {}));
